module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-LightItalic.d6a1169.eot";